export default __webpack_public_path__ + "static/media/black-logo.5440dc6c.png";